import { render, staticRenderFns } from "./colorSwitch.vue?vue&type=template&id=5eafc956&scoped=true&"
import script from "./colorSwitch.vue?vue&type=script&lang=js&"
export * from "./colorSwitch.vue?vue&type=script&lang=js&"
import style0 from "./colorSwitch.vue?vue&type=style&index=0&id=5eafc956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eafc956",
  null
  
)

export default component.exports